import type { FC, SVGProps } from "react";

const IconFreeExcursions: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M15.2398 6.76001L13.4358 12.171C13.3376 12.4656 13.1722 12.7333 12.9526 12.9528C12.733 13.1724 12.4653 13.3378 12.1708 13.436L6.75977 15.24L8.56377 9.82901C8.66195 9.53443 8.82737 9.26675 9.04694 9.04718C9.26651 8.82762 9.53418 8.66219 9.82877 8.56401L15.2398 6.76001Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconFreeExcursions;
